module.exports = __webpack_public_path__ + "static/media/cross.dfec1af6.jpg";